<template>
  <v-container class="d-flex flex-column align-center" style="height: 100vh; padding-top: 20px;">
    <img
      src="404nbg.png"
      width="600"
      alt="MediaAnalytics"
      class="image-top mb-4"
    />

    <v-row>
      <v-col cols="12" class="text-center">
        <h1 class="combined-text">
          <span class="media-text">PAGE</span> <span class="analytics-text">NOT FOUND</span>
        </h1>
      </v-col>
    </v-row>

    <div>
      <Notification ref="alert"></Notification>
    </div>
  </v-container>
</template>

<script>
import axios from "axios";
import Notification from '@/components/Notification';
export default {
  name: 'MediaAnalyticComponent',
  components: {
    Notification
  },
  mounted() {
    this.loadCekSessionLogin();
  },
  methods: {
    async loadCekSessionLogin() {
      try {
        const token = localStorage.getItem('token_app');
        const decodeResponse = await axios.post("decode-token", { token });

        if (!decodeResponse.data.valid) {
          throw { response: { status: 403 } };
        }
      } catch (e) {
        const { status } = e.response || {};

        switch (status) {
          case 404:
            this.$refs.alert.error_login(404);
            break;
          case 403:
            this.$refs.alert.error_login(403);
            break;
          default:
            console.log("some other error");
            break;
        }
        return;
      }
    }
  }
};
</script>

<style scoped>
.image-top {
  margin-top: -60px;
}

.combined-text {
  font-size: 48px;
  font-weight: bold;
}

.media-text {
  color: #007bff;
}

.analytics-text {
  color: #000000;
}
</style>
